<template>
    <div class="move">
        <div v-if="isTopLeft" id="cloud_top_left"></div>
        <div v-if="isFooterRight" id="cloud_footer_right"></div>
        <div v-if="isFooterLeft" id="cloud_footer_left"></div>
    </div>
</template>

<script>
    export default {
        name: "Cloud",
        props: {
            isTopLeft: { type: Boolean, default: false },
            isFooterRight: { type: Boolean, default: false },
            isFooterLeft: { type: Boolean, default: false }
        }
    }
</script>

<style scoped>
    .move>div{ position: fixed; }
    @keyframes moveLeft { from {background-position: -2400% 0} to {background-position: 2400% 0} }
    @-webkit-keyframes moveLeft { from {background-position: -2400% 0} to {background-position: 2400% 0} }
    @keyframes moveRight { from {background-position: 2400% 0} to {background-position: -2400% 0} }
    @-webkit-keyframes moveRight { from {background-position: 2400% 0} to {background-position: -2400% 0} }
    #cloud_top_left{
        z-index: 10;
        opacity: 0.8;
        top: 0; left: 0; bottom: 0; right: 0;
        background:url('../assets/img/cloud_top.png') repeat-x 35%;
        animation: moveLeft 800s linear infinite;
    }
    #cloud_footer_right{
        z-index: 25;
        opacity: 0.9;
        top: 0; left: 0; bottom: 0; right: 0;
        background:url('../assets/img/cloud_footer.png') repeat-x 20%;
        animation: moveRight 400s linear infinite;
    }
    #cloud_footer_left{
        z-index: 25;
        opacity: 0.9;
        top: 0; left: 0; bottom: 0; right: 0;
        background:url('../assets/img/cloud_footer.png') repeat-x 20%;
        animation: moveLeft 400s linear infinite;
    }
</style>
